import Vue from "vue";
import App from "./App";
import router from "./router";
import jquery from "jquery";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BootstrapVue from "bootstrap-vue";
import EasySlider from "vue-easy-slider";

import VueLocalStorage from "vue-localstorage";
import { i18n } from "@/translations";

import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import VueCarousel from "vue-carousel";
import { Network } from "vue2vis";

import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

//Simple Alert
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

Vue.use(VueCarousel);
Vue.use(BootstrapVue);
Vue.use(EasySlider);
Vue.use(Network);
Vue.use(VueLocalStorage);
Vue.config.productionTip = false;

Vue.component("v-marker-cluster", Vue2LeafletMarkerCluster);
window.jQuery = jquery;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js